const actions_constant = {
    LOGIN_INFO: 'LOGIN_INFO',
    DISPLAY_CHANGE: 'DISPLAY_CHANGE',
    LOGOUT: 'LOGOUT',
}

export default actions_constant